import {
  RuleOperator,
  RuleTypes,
  SlotLabel,
  UserRequirement,
  UserRequirementType,
} from '@youshift/shared/types';
import { TFunction } from 'i18next';

import { RuleWithInclusionType, UserConfig } from './types';

interface ValidationResult {
  isValid: boolean;
  error?: string;
}

export const hasInvalidReqs = (
  roles: Record<
    string,
    {
      users: UserConfig[];
    }
  >,
  reqType: UserRequirementType,
): ValidationResult => {
  // Check if any user is included
  const anyIncluded = Object.values(roles).some(role =>
    role.users.some(user => user.included),
  );

  if (!anyIncluded) {
    return {
      isValid: false,
      error: 'manager.rulesConfig.noUserIncluded',
    };
  }

  // Check min/max constraints
  const invalidUser = Object.values(roles).find(role =>
    role.users.find(user => {
      if (!user.included) return false;
      switch (reqType) {
        case UserRequirementType.DURATION:
          return (
            user.min_duration !== undefined &&
            user.min_duration !== null &&
            user.max_duration !== undefined &&
            user.max_duration !== null &&
            user.min_duration > user.max_duration
          );
        case UserRequirementType.COUNTER_UNIT:
          return (
            user.min_counter_unit !== undefined &&
            user.min_counter_unit !== null &&
            user.max_counter_unit !== undefined &&
            user.max_counter_unit !== null &&
            user.min_counter_unit > user.max_counter_unit
          );
        case UserRequirementType.SLOTS:
          return (
            user.min_slots !== undefined &&
            user.min_slots !== null &&
            user.max_slots !== undefined &&
            user.max_slots !== null &&
            user.min_slots > user.max_slots
          );
        default:
          return false;
      }
    }),
  );

  if (invalidUser) {
    return {
      isValid: false,
      error:
        reqType === UserRequirementType.DURATION
          ? 'manager.rulesConfig.invalidDurationConstraints'
          : reqType === UserRequirementType.COUNTER_UNIT
            ? 'manager.rulesConfig.invalidCounterUnitConstraints'
            : 'manager.rulesConfig.invalidSlotsConstraints',
    };
  }

  return { isValid: true };
};

export const isExclusionRuleRequirement = (userReq: UserRequirement) => {
  switch (userReq.req_type) {
    case UserRequirementType.DURATION:
      return userReq.min_duration === 0 && userReq.max_duration === 0;
    case UserRequirementType.SLOTS:
      return userReq.min_slots === 0 && userReq.max_slots === 0;
    case UserRequirementType.COUNTER_UNIT:
      return userReq.min_counter_unit === 0 && userReq.max_counter_unit === 0;
    default:
      return false;
  }
};
